function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgMusicNoteDouble(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M9 10.22v-.282c0-.696.469-1.266 1.136-1.434l8.184-2.188a.937.937 0 011.18.903V8.25",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M19.5 13.872v3.75c0 .652-.419 1.2-1.031 1.407l-1.032.375c-1.214.408-2.437-.489-2.437-1.782a1.564 1.564 0 011.078-1.5l2.39-.85c.613-.207 1.032-.748 1.032-1.4zm0 0V2.72a.468.468 0 00-.59-.45L9.561 4.78a.773.773 0 00-.562.75v10.594c0 .652-.419 1.2-1.031 1.406l-2.438.844c-.65.22-1.031.807-1.031 1.5 0 1.293 1.243 2.182 2.438 1.781l1.03-.375C8.582 21.075 9 20.528 9 19.875v-3.75",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgMusicNoteDouble;